module.exports = __webpack_public_path__ + "media/images/athletes/139-fdbed9434b9497122fa4280cc79ccc82.png";